import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Textinput, Typo, Figure, CourseImageWrapper } from '../../../../ui';
import ImageUploader from '../../../media/uploaders/ImageUploader';
import {
  setCourseName,
  setCoverImage,
  selectGuideCourseName,
  selectGuideCoverImage,
} from '../../courseGuideState';

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StepHeader = styled.div`
  margin-bottom: 8px;
`;

const ImageSection = styled.div`
  max-width: 400px;
`;

const StepNameAndCover = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const courseName = useSelector(selectGuideCourseName);
  const coverImage = useSelector(selectGuideCoverImage);

  const handleNameChange = useCallback(
    (e) => dispatch(setCourseName(e.target.value)),
    [dispatch],
  );

  const handleImageSave = useCallback(
    (image) => {
      if (image) dispatch(setCoverImage(image));
    },
    [dispatch],
  );

  const imageUrl = coverImage?.url || (Array.isArray(coverImage) && coverImage[0]?.url);

  return (
    <StepWrapper>
      <StepHeader>
        <Typo.ContentBigHeader>{t('courseGuide.step.nameAndCover')}</Typo.ContentBigHeader>
        <Typo.SmallText>{t('courseGuide.stepDesc.nameAndCover')}</Typo.SmallText>
      </StepHeader>

      <Textinput
        label={t('course.courseName')}
        value={courseName}
        onChange={handleNameChange}
        autoFocus
      />

      <ImageSection>
        <Typo.TextTitle $marginBottom='8px'>{t('webshop.addCoverImage')}</Typo.TextTitle>
        <CourseImageWrapper>
          <ImageUploader
            type='single'
            id='courseGuideImage'
            saveAction={handleImageSave}
            imageToPreview={imageUrl}
            label={t('webshop.addCoverImage')}
            iconName='Add'
          >
            {imageUrl && (
              <Figure.Rectangle>
                <img alt={t('webshop.addCoverImage')} src={imageUrl} loading='lazy' />
              </Figure.Rectangle>
            )}
          </ImageUploader>
        </CourseImageWrapper>
      </ImageSection>
    </StepWrapper>
  );
};

export default StepNameAndCover;
